import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ScrollPositionService {

  readonly bottomReached: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor() { }
}
